import map from 'lodash/map'

const requiredFields = {
  category_id: {
    title: 'Category',
    rule: '',
  },
  description: {
    title: 'Description',
    rule: ''
  },
  min_guests: {
    title: 'Min Guests',
    rule: '',
  },
  max_guests: {
    title: 'Max Guests',
    rule: '',
  },
  images: {
    title: 'images',
    rule: ''
  }
}

const validator = value => {
  const errors = {}

  map(requiredFields, ({ max, min, title }, field) => {
    if (!value[field]) {
      errors[field] = `${title} field is required`
    } else if (value[field].length > max) {
      errors[field] = `Field reached ${max} characters`
    } else if (value[field].length < min) {
      errors[field] = `Field requires a minimum of ${min} characters`
    } else if (
      field === 'email' &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value[field])
    ) {
      errors[field] = `Invalid email format`
    }
  })

  return errors
}

export default validator
